import ScrollObserver from '../core/scrollObserver';

export default class FloatCtaFooterHide extends ScrollObserver {
  constructor(target = '.footer__contact', opt = {}) {
    opt = Object.assign({
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.01, 1],
    }, opt);
    super(opt);

    this.ctaSelector = '.bfb-common-cta, .bfb-common-cta-sp';
    this.hiddenClass = 'is-near-footer';
    this.target = document.querySelector(target);
    if (!this.target) return;

    this.observeElement(target);
    this.syncFromTarget();
    window.addEventListener('resize', () => this.syncFromTarget(), { passive: true });
  }

  // 交差の有無ではなく「トリガー上端を超えたか」で判定
  callback() {
    this.syncFromTarget();
  }

  syncFromTarget() {
    if (!this.target) return;
    const passed = this.target.getBoundingClientRect().top < window.innerHeight;
    this.toggleCta(passed);
  }

  toggleCta(hidden) {
    document.querySelectorAll(this.ctaSelector).forEach((el) => {
      el.classList.toggle(this.hiddenClass, hidden);
    });
  }
}
